var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMediumLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 700 700",
    style: {
      enableBackground: "new 0 0 700 700"
    },
    fill: "none",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".st0{fill:#FFFFFF;}")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 199.5,
    cy: 350,
    r: 199.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 512.7,
    cy: 350,
    rx: 101.5,
    ry: 189
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 663.2,
    cy: 350,
    rx: 36.8,
    ry: 171.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediumLogoWhite);
export default __webpack_public_path__ + "static/media/medium-logo-white.93204eccfa5f01e5ba50e921142ce320.svg";
export { ForwardRef as ReactComponent };